/* RESPONSIBLE TEAM: team-fin-nux */
import { inject as service } from '@ember/service';
import Helper from '@ember/component/helper';

interface OpenTutorialSignature {
  Args: {
    Positional: [string, string, string];
  };
  Return: () => void;
}

export function openTutorial(
  tutorialId: string,
  place: string,
  section: string,
  modalService: any,
) {
  modalService.openModal(
    'react/fin-tutorials/fin-tutorials-modal',
    {
      tutorialId,
      place,
      section,
      onOpenChange: () => {
        modalService.closeModal();
      },
    },
    {},
    {},
  );
}

export default class OpenTutorial extends Helper<OpenTutorialSignature> {
  @service declare modalService: any;

  compute([tutorialId, place, section]: [string, string, string]): () => void {
    return () => {
      this.modalService.openModal(
        'react/fin-tutorials/fin-tutorials-modal',
        {
          tutorialId,
          place,
          section,
          onOpenChange: () => {
            this.modalService.closeModal();
          },
        },
        {},
        {},
      );
    };
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'open-tutorial': typeof OpenTutorial;
  }
}
